import L from "leaflet";
import { Fragment, useEffect, useRef } from "react";
import {
  Circle,
  CircleMarker,
  MapContainer,
  Marker,
  Polyline,
  TileLayer,
  useMap,
} from "react-leaflet";

import { blueIcon } from "../pages/ReviewDetail";
import { MAPBOX_SATELLITE_TILE_URL } from "../utils/mapbox";

export function ChangeView({ markers, current }) {
  const map = useMap();

  useEffect(() => {
    if (markers && markers.length > 0) {
      // For subsquent ones, zoom in unto the specific marker
      let marker = markers[current];
      if (marker.latitude && marker.longitude) {
        const bounds = L.latLng(marker.latitude, marker.longitude).toBounds(30);
        map.fitBounds(bounds);
      }
    }
  }, [markers, current, map]);
  return null;
}

function Ruler({ data }) {
  if (!data || !data.latitude || !data.longitude) return null;
  const { latitude, longitude } = data;

  const metersPerDegLat = 111111;
  const metersPerDegLng = 111111 * Math.cos(latitude * (Math.PI / 180));

  const offsetSouthMeters = 15;
  const rulerLat = latitude - offsetSouthMeters / metersPerDegLat;

  const rulerWidthMeters = 30;
  const halfWidthMeters = rulerWidthMeters / 2;

  const tickSize = 2; // meters
  const tickDegLat = tickSize / metersPerDegLat;

  // Create points for a centered horizontal ruler
  const points = [0, 10, 20, 30].map((m) => {
    // m goes from 0 to 30.
    // We want 0 to be at -15m (West) and 30 to be at +15m (East) relative to center
    const metersFromCenter = m - halfWidthMeters;
    const lngOffset = metersFromCenter / metersPerDegLng;

    return {
      tick: [
        [rulerLat - tickDegLat / 2, longitude + lngOffset],
        [rulerLat + tickDegLat / 2, longitude + lngOffset],
      ],
      base: [rulerLat, longitude + lngOffset],
    };
  });

  const mainLine = [points[0].base, points[3].base]; // Start to end
  const tickLines = points.map((p) => p.tick);

  const textIcon = L.divIcon({
    html: `<div class="text-white text-xs font-bold whitespace-nowrap" style="transform: translate(-50%, 0); text-shadow: 0px 0px 2px black;">30m</div>`,
    className: "",
    iconSize: [0, 0],
  });

  return (
    <Fragment>
      <Polyline
        positions={[mainLine, ...tickLines]}
        color="white"
        weight={3}
        opacity={0.5}
      />
      <Marker
        position={points[3].tick[0]}
        icon={textIcon}
        interactive={false}
      />
    </Fragment>
  );
}

function MapData({ allData, data, current }) {
  const circleRefs = useRef();
  const mapRef = useRef();
  useEffect(() => {
    if (mapRef.current && data.latitude && data.longitude) {
      mapRef.current.setView(
        [data.latitude, data.longitude],
        mapRef.current.getZoom(),
      );
    }
  }, [data]);

  return (
    <div className="relative w-full h-64">
      <MapContainer
        className=" border border-gray-200"
        center={[data.latitude, data.longitude]}
        style={{
          height: "100%",
          width: "100%",
        }}
        scrollWheelZoom={false}
        dragging={false}
        zoomControl={false}
        doubleClickZoom={false}
        attributionControl={false}
      >
        <style>
          {`
            .leaflet-control-attribution,
            .gmnoprint,
            .gm-style-cc {
              display: none !important;
            }
          `}
        </style>
        <ChangeView markers={allData} current={current} />
        <TileLayer url={MAPBOX_SATELLITE_TILE_URL} />
        <Circle
          center={{
            lat: data.latitude,
            lng: data.longitude,
          }}
          ref={(r) => {
            circleRefs.current = r;
          }}
          radius={10}
          pathOptions={{ dashArray: "5", fillOpacity: 0 }}
        >
          <Marker
            position={{
              lat: data.latitude,
              lng: data.longitude,
            }}
            icon={blueIcon}
            autoPan={false}
          />

          <CircleMarker
            center={{
              lat: data.latitude,
              lng: data.longitude,
            }}
            color={"gray"}
            fillOpacity={0}
            radius={1}
          />
        </Circle>
        <Ruler data={data} />
      </MapContainer>
    </div>
  );
}
export default MapData;
